export default __webpack_public_path__ + "img/pin_icons/horn_strobe_w.svg";